import { render, staticRenderFns } from "./PostTable.vue?vue&type=template&id=122acf98&scoped=true"
import script from "./PostTable.vue?vue&type=script&lang=js"
export * from "./PostTable.vue?vue&type=script&lang=js"
import style0 from "./PostTable.vue?vue&type=style&index=0&id=122acf98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "122acf98",
  null
  
)

export default component.exports